// extracted by mini-css-extract-plugin
module.exports = {"ad":"ad-2lQ3Zhq1"};